import Store from "@/vuex/store";
import Router from "@/router/router";

/**
 * Commit a flight_offer to the liveflight store and (optionally)
 * navigate. trigger_search is flipped on every selection so a later
 * return to /results (btn-back / Annulla) refetches fresh offers
 * instead of rendering stale post-detail-page prices.
 *
 * @param {object} flight_offer canonical FlightOffer
 * @param {string} [path] route path; skipped when empty or unchanged
 */
export function select_flight_offer(flight_offer, path = "") {
  Store.commit("liveflight/select_flight_offer", flight_offer);
  Store.commit("liveflight/trigger_search", true);
  Store.commit("booking_data", {});
  if (path === "") return;
  if (Router.history.current.path === path) return;
  Router.push({ path: path });
}
